// extracted by mini-css-extract-plugin
export default {"popUpWrapper":"PopUp_popUpWrapper__wWJQI","popUpContainer":"PopUp_popUpContainer__jUl6T","popUpText":"PopUp_popUpText__cMJcA","popUpCloseButton":"PopUp_popUpCloseButton__6zZTt"};